import { useMutation, useQueryCache } from "react-query";
import {
  API_KEY_GET_TRANSLATION,
  API_KEY_GET_TRANSLATION_LIST,
} from "../constants";
import { _t } from "../../../../../modules/Common/components/InjectIntlContext";
import { notify } from "../../../../../system/utils/notification";
import { postTranslation } from "../api";

export const usePostTranslation = (id?) => {
  const successMessage = _t("successfully_sent");
  const queryCache = useQueryCache();

  return useMutation(postTranslation, {
    onSuccess: (data, variables) => {
      queryCache.invalidateQueries(API_KEY_GET_TRANSLATION, id);
      queryCache.invalidateQueries(API_KEY_GET_TRANSLATION_LIST);
      notify("success", successMessage);
    },
  });
};
